<template>
  <widget
    :type="widget.type"
    :title="widget.title"
    :subtitle="widget.subtitle"
    :url="widget.url"
    :availability="widget.availability"
    :viewData="widget.viewData"
    :view="widget.view"
    @update:type="widget.type = $event"
    @update:title="widget.title = $event"
    @update:subtitle="widget.subtitle = $event"
    @update:url="widget.url = $event"
    @update:availability="widget.availability = $event"
    @update:viewData="widget.viewData = $event"
    @update:view="widget.view = $event"
  >
    <b-row class="align-items-center">
      <b-col md="6" xl="3" class="mb-2 mb-md-0">
        <b-input-group :prepend="$t('widgetAreas.count')">
          <numeric-input v-model="widget.count"/>
        </b-input-group>
      </b-col>

      <b-col md=6 xl="9" class="mb-0">
        <b-input-group :prepend="$t('shared.tags')">
          <b-form-tags
            :placeholder="`${$t('shared.add')}...`"
            :add-button-text="$t('shared.add')"
            add-button-variant="light"
            tag-variant="warning"
            tag-pills
            :tag-remove-label="$t('shared.remove')"
            :duplicate-tag-text="$t('shared.duplicateItem', { title: this.$t('shared.tag') })"
            :invalid-tag-text="$t('shared.invalidItem', { title: this.$t('shared.tag') })"
            separator=",،"
            remove-on-delete
            v-model="widget.tags"
          />
        </b-input-group>
      </b-col>
    </b-row>
  </widget>
</template>

<script>
import EditorMixin from './EditorMixin'
import Widget from '../Widget'

export default {
  name: 'BrandsWidget',
  mixins: [EditorMixin],
  components: {
    Widget,
  },
  props: {
    widget: { type: Object, required: true }
  }
}
</script>
